
import AlertModule from 'vux/src/plugins/alert/module'

export default {
data () {
return {
id_no: '',
password: '',
showNo: false,
showPass: false,
showPrise: false,
num: -1,
priseList: []
}
},

methods: {
idNoFocus () {
this.showNo = true
},
passwordFocus () {
this.showPass = true
},
idNoBurl () {
if (this.id_no === '') {
this.showNo = false
}
},
passwordBurl () {
if (this.password === '') {
this.showPass = false
}
},
login () {








if (this.id_no === '') {
AlertModule.show({
title: '提示',
content: '请输入用户名',
buttonText: '确定'
})
} else if (this.password === '') {
AlertModule.show({
title: '提示',
content: '请输入密码',
buttonText: '确定'
})
} else {
this.$axios.post('/shuian/public/mobile/trace/login', { 'id_no': this.id_no, 'password': this.password }, { 'headers': { 'Content-Type': 'application/json' } })
.then(res => {
console.log(res.data.data)
if (res.data.code === 200) {
this.$router.push({ path: '/matrix' })
localStorage.setItem('loginUser', JSON.stringify(res.data.data.loginUser))
localStorage.setItem('fenceList', JSON.stringify(res.data.data.fence))
this.id_no = ''
this.password = ''
this.showNo = false
this.showPass = false
} else if (res.data.code === 202) {
this.priseList = res.data.data
console.log(this.priseList)
this.showPrise = true
} else {
AlertModule.show({
title: '提示',
content: res.data.codeInfo,
buttonText: '确定'
})
}
})
.catch(error => {
AlertModule.show({
title: '提示',
content: error,
buttonText: '确定'
})
})
}
},
selectEnterprise (cur, i) {
this.num = i
this.$axios.post('/shuian/public/mobile/trace/login', { 'id_no': this.id_no, 'password': this.password, 'enterprise_id': cur.enterprise_id }, { 'headers': { 'Content-Type': 'application/json' } })
.then(res => {
console.log(res.data.data)
if (res.data.code === 200) {
this.$router.push({ path: '/matrix' })
localStorage.setItem('loginUser', JSON.stringify(res.data.data.loginUser))
localStorage.setItem('fenceList', JSON.stringify(res.data.data.fence))
this.id_no = ''
this.password = ''
this.showNo = false
this.showPass = false
} else {
AlertModule.show({
title: '提示',
content: res.data.codeInfo,
buttonText: '确定'
})
}
})
.catch(error => {
AlertModule.show({
title: '提示',
content: error,
buttonText: '确定'
})
})
},
closedToast () {
this.showPrise = false
}
}
}
